export enum Incoterms {
CFR=0,
DAP=10,
DAT=20,
DDP=30,
EXW=40,
FOB=50,
}